import React, { useEffect, useState } from 'react';
import { TEXT_PLACEHOLDER_KEY_RE } from '../../utils/text-placeholders';
import studioStyles from './scenario-studio.module.css';

interface CreateTextPlaceholderModalProps {
  initialKey: string;
  onClose: () => void;
  onSubmit: (payload: { key: string; value: string; label?: string }) => Promise<void>;
}

export function CreateTextPlaceholderModal({
  initialKey,
  onClose,
  onSubmit,
}: CreateTextPlaceholderModalProps) {
  const [key, setKey] = useState(initialKey);
  const [value, setValue] = useState('');
  const [label, setLabel] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setKey(initialKey);
  }, [initialKey]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const trimmedKey = key.trim();
    const trimmedValue = value.trim();
    if (!trimmedKey) {
      setError('La clé est obligatoire.');
      return;
    }
    if (!TEXT_PLACEHOLDER_KEY_RE.test(trimmedKey)) {
      setError('Clé invalide : lettres, chiffres, _ ou - (commence par une lettre).');
      return;
    }
    if (!trimmedValue) {
      setError('La valeur est obligatoire.');
      return;
    }

    setSaving(true);
    setError(null);
    try {
      await onSubmit({
        key: trimmedKey,
        value: trimmedValue,
        label: label.trim() || undefined,
      });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Échec de la création');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={studioStyles.modalOverlay} onClick={saving ? undefined : onClose}>
      <div className={studioStyles.modal} onClick={(event) => event.stopPropagation()}>
        <header className={studioStyles.modalHeader}>
          <h3>Créer un placeholder</h3>
          <button type="button" className={studioStyles.iconBtn} onClick={onClose} disabled={saving}>
            ×
          </button>
        </header>
        <form className={studioStyles.modalBody} onSubmit={handleSubmit}>
          <div className={studioStyles.field}>
            <label htmlFor="placeholder-key">Clé</label>
            <input
              id="placeholder-key"
              className={studioStyles.input}
              value={key}
              onChange={(event) => setKey(event.target.value)}
              placeholder="hero_name"
              autoFocus
            />
          </div>
          <div className={studioStyles.field}>
            <label htmlFor="placeholder-value">Valeur (ce scénario)</label>
            <input
              id="placeholder-value"
              className={studioStyles.input}
              value={value}
              onChange={(event) => setValue(event.target.value)}
              placeholder="Alice"
            />
          </div>
          <div className={studioStyles.field}>
            <label htmlFor="placeholder-label">Libellé (optionnel, global)</label>
            <input
              id="placeholder-label"
              className={studioStyles.input}
              value={label}
              onChange={(event) => setLabel(event.target.value)}
              placeholder="Nom du héros"
            />
          </div>
          {error ? <p className={studioStyles.errorText}>{error}</p> : null}
          <footer className={studioStyles.modalFooter}>
            <button type="button" className={studioStyles.btnSecondary} onClick={onClose} disabled={saving}>
              Annuler
            </button>
            <button type="submit" className={studioStyles.btnPrimary} disabled={saving}>
              {saving ? 'Enregistrement…' : 'Créer'}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
}
